import { Action } from '@ngrx/store';

export enum ReportActionTypes {

    GENERATE_JOB_REPORT = '[Job] GENERATE Report',
    GENERATE_JOB_REPORT_SUCCESS = '[Job] GENERATE Report Success',
    GENERATE_JOB_REPORT_FAILURE = '[Job] GENERATE Report Failure',

    GET_JOB_REPORTS = '[Job] GET Reports',
    GET_JOB_REPORTS_SUCCESS = '[Job] GET Reports Success',
    GET_JOB_REPORTS_FAILURE = '[Job] GET Reports Failure',

    GENERATE_PAGE_REPORT = '[Page] GENERATE Report',
    GENERATE_PAGE_REPORT_SUCCESS = '[Page] GENERATE Report Success',
    GENERATE_PAGE_REPORT_FAILURE = '[Page] GENERATE Report Failure',

    GET_PAGE_REPORTS = '[Page] GET Reports',
    GET_PAGE_REPORTS_SUCCESS = '[Page] GET Reports Success',
    GET_PAGE_REPORTS_FAILURE = '[Page] GET Reports Failure',

}

// REPORTS
export class GenerateJobReport implements Action {
  readonly type = ReportActionTypes.GENERATE_JOB_REPORT;
  constructor(public payload: any) {}
}
export class GenerateJobReportSuccess implements Action {
  readonly type = ReportActionTypes.GENERATE_JOB_REPORT_SUCCESS;
  constructor(public payload: any) {}
}
export class GenerateJobReportFailure implements Action {
  readonly type = ReportActionTypes.GENERATE_JOB_REPORT_FAILURE;
  constructor(public payload: any) {}
}

export class GetJobReports implements Action {
  readonly type = ReportActionTypes.GET_JOB_REPORTS;
  constructor(public payload: any) {}
}
export class GetJobReportsSuccess implements Action {
  readonly type = ReportActionTypes.GET_JOB_REPORTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetJobReportsFailure implements Action {
  readonly type = ReportActionTypes.GET_JOB_REPORTS_FAILURE;
  constructor(public payload: any) {}
}

export class GeneratePageReport implements Action {
  readonly type = ReportActionTypes.GENERATE_PAGE_REPORT;
  constructor(public payload: any) {}
}
export class GeneratePageReportSuccess implements Action {
  readonly type = ReportActionTypes.GENERATE_PAGE_REPORT_SUCCESS;
  constructor(public payload: any) {}
}
export class GeneratePageReportFailure implements Action {
  readonly type = ReportActionTypes.GENERATE_PAGE_REPORT_FAILURE;
  constructor(public payload: any) {}
}

export class GetPageReports implements Action {
  readonly type = ReportActionTypes.GET_PAGE_REPORTS;
  constructor(public payload: any) {}
}
export class GetPageReportsSuccess implements Action {
  readonly type = ReportActionTypes.GET_PAGE_REPORTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetPageReportsFailure implements Action {
  readonly type = ReportActionTypes.GET_PAGE_REPORTS_FAILURE;
  constructor(public payload: any) {}
}

export type All =
| GenerateJobReport
| GenerateJobReportSuccess
| GenerateJobReportFailure
| GetJobReports
| GetJobReportsSuccess
| GetJobReportsFailure
| GeneratePageReport
| GeneratePageReportSuccess
| GeneratePageReportFailure
| GetPageReports
| GetPageReportsSuccess
| GetPageReportsFailure



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/report.actions.ts